import { useTranslation } from "react-i18next";
import MainHeader from "../../components/layout/MainHeader";
import PageHeader from "../../components/layout/PageHeader";
import Footer from "../../components/layout/Footer";
import useAnimateCss, { useAnimateCssStagger } from "../../hooks/useAnimateCss";

import headerImg from "../../assets/images/main-slider/image-0.jpg";
import imgAbout from "../../assets/images/about/about.jpg";
import imgVision from "../../assets/images/about/vision.jpg";
import imgMission from "../../assets/images/about/mission.jpg";

import img1 from "../../assets/images/sponsors/1.png";
import img3 from "../../assets/images/sponsors/3.png";
import img4 from "../../assets/images/sponsors/4.png";
import img5 from "../../assets/images/sponsors/5.png";
import img6 from "../../assets/images/sponsors/6.png";
import arabia from "../../assets/images/sponsors/arabia.png";
import concord from "../../assets/images/sponsors/concord.png";
import nat from "../../assets/images/sponsors/nat.png";
import sodic from "../../assets/images/sponsors/sodic.png";
import sun from "../../assets/images/sponsors/sun.png";
import tatweer from "../../assets/images/sponsors/tatweer.png";

import AboutPreview from "../../components/about/AboutPreview";
import WhyChooseUs from "../../components/home/WhyChooseUs";



function AboutSection({
  label,
  heading,
  children,
  image,
  reverse = false,
}: {
  label: string;
  heading: string;
  children: React.ReactNode;
  image: string;
  reverse?: boolean;
}) {
  const labelRef = useAnimateCss("animate__fadeInDown", 0,   0.12);
  const headRef  = useAnimateCss("animate__fadeInUp",   100, 0.12);
  const textRef  = useAnimateCss("animate__fadeInUp",   200, 0.12);
  const imgRef   = useAnimateCss(
    reverse ? "animate__fadeInLeft" : "animate__fadeInRight",
    150, 0.1, 800,
  );

  return (
    <section className="about-inner-section">
      <div className="container">
        <div
          className={`row align-items-center g-5${reverse ? " flex-lg-row-reverse" : ""}`}
        >
          {/* Text */}
          <div className="col-lg-6">
            <span className="page-section-label" ref={labelRef as any}>{label}</span>
            <h2 className="inner-page-heading" ref={headRef as any}>{heading}</h2>
            <div className="inner-page-text" ref={textRef as any}>{children}</div>
          </div>

          {/* Image */}
          <div className="col-lg-6">
            <img src={image} alt={heading} className="about-inner-image" ref={imgRef as any} />
          </div>
        </div>
      </div>
    </section>
  );
}

function About() {
  const { t } = useTranslation();

  const missionPoints = t("mission_text_points", {
    returnObjects: true,
  }) as string[];

  const spHeadRef  = useAnimateCss("animate__fadeInDown", 0,   0.15);
  const spSubRef   = useAnimateCss("animate__fadeInUp",   120, 0.15);
  const spCardsRef = useAnimateCssStagger("animate__zoomIn", 80, 0.08, 600);

  return (
    <>
      <MainHeader />
      <PageHeader image={headerImg} title={t("About Us")} />

      {/* ── Who We Are ── */}
      <AboutPreview />

      <WhyChooseUs />

      {/* ── Vision ── */}
      {/* <AboutSection
        label={t("Our Vision")}
        heading={t("Our Vision")}
        image={imgVision}
        reverse
      >
        <p>{t("vision-info")}</p>
      </AboutSection> */}

      {/* ── Mission ── */}
      {/* <AboutSection
        label={t("Our Mission")}
        heading={t("Our Mission")}
        image={imgMission}
      >
        <p>{t("mission_text_intro")}</p>
        {missionPoints.map((point, i) => (
          <p key={i}>{point}</p>
        ))}
        <p>{t("mission_text_conclusion")}</p>
        <p>{t("mission_text_last")}</p>
      </AboutSection> */}

      {/* ── Values ── */}
      {/* <AboutSection
        label={t("Our Values")}
        heading={t("Our Values")}
        image={imgAbout}
        reverse
      >
        <p>{t("excellence")}</p>
        <p>{t("commitment")}</p>
        <p>{t("safety")}</p>
        <p>{t("professional_integrity")}</p>
        <p>{t("social_responsibility")}</p>
      </AboutSection> */}

      {/* ── Success Partners ── */}
      <section className="success-partners-section">
        <div className="container text-center">
          <h2 className="sp-heading" ref={spHeadRef as any}>{t("OUR SUCCESS PARTNERS")}</h2>
          <p className="sp-sub" ref={spSubRef as any}>{t("sponsores-text")}</p>
          <div className="row g-3 justify-content-center" ref={spCardsRef as any}>
            {[
              img1,
              img3,
              img4,
              img5,
              img6,
              arabia,
              concord,
              nat,
              sodic,
              tatweer,
            ].map((src, i) => (
              <div key={i} className="col-lg-3 col-sm-6">
                <div className="sp-card">
                  <img src={src} alt="partner" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default About;
